export default __webpack_public_path__ + "static/media/element_spec_60.68aaebfe.webp";